module.exports = __webpack_public_path__ + "static/img/tabbar_mine_normal@2x.47f63e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar_mine_normal@2x.png
// module id = ZirD
// module chunks = 1